import * as React from 'react';
import dynamic from 'next/dynamic';
import { GetStaticProps } from 'next';

import { getServerTranslations } from '../../get-server-side-translations';

const AskForReferralContent = dynamic(() => import('../../components/ask-for-referral/ask-for-referral-content'), {
  ssr: false,
});

const AskForReferralPage: React.FunctionComponent = () => {
  return <AskForReferralContent />;
};

export default AskForReferralPage;

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const transConfig = await getServerTranslations(locale, ['common', 'ask-for-referral', 'restaurant-onboarding']);
  return {
    props: {
      ...transConfig,
    },
  };
};
